<template>
    <div>
        <div class="-wrapper-column">
            <div class="-step">
                <button v-bind:class="classStep1" @click="onSelectStep(1)">
                    <em></em>
                    <span>{{ $t('POLICY.ADD_POPUP.ADD_STEP_1')}}</span>
                </button>
                <button v-show="(vendors || []).length > 0" v-bind:class="classStep2" @click="onSelectStep(2)">
                    <em></em>
                    <span>{{ $t('POLICY.ADD_POPUP.ADD_STEP_2')}}</span>
                </button>
                <button v-show="(vendors || []).length > 0" v-bind:class="classStep3" @click="onSelectStep(3)">
                    <em></em>
                    <span>{{ $t('POLICY.ADD_POPUP.ADD_STEP_3')}}</span>
                </button>
            </div>
            <div class="-wrapper-column h-center- step-body">
                <div v-if="isShowStep1" style="width: 100%">
                    <fieldset class="forms">
                        <legend>{{ $t('POLICY.ADD_POPUP.SELECT_ASSESSMENT_TYPE')}}</legend>
                        <p style="padding-bottom: 5px;">{{ $t('POLICY.ADD_POPUP.DESC_STEP_1')}}</p>
                        <div class="form-item">
                            <input type="checkbox"
                                id="right-now"
                                v-model="doCmpl">
                                    <label for="right-now">{{ $t('POLICY.ADD_POPUP.COMPLIANCE_IMMEDIATELY')}}</label>
                        </div>
                        <div class="form-item">
                            <input type="checkbox"
                                id="set-schedule"
                                name="set-schedule"
                                v-model="isSchedule">
                                    <label for="set-schedule">{{ $t('POLICY.ADD_POPUP.CREATE_SCHEDULE')}}</label>
                        </div>
                    </fieldset>
                    <div style="padding: 0 25px;">
                        <HorizontalSchedule
                            class="body-message-sche"
                            v-show="isSchedule"
                            ref="commonSchedule"
                            :callSetScheInfo="callSetScheInfo"
                        />
                    </div>
                </div>
                <div v-if="isShowStep2" style="width: 100%">
                    <p>{{ $t('POLICY.ADD_POPUP.DESC_STEP_2')}}</p>
                    <GroupSelect class="mt-4"
                        id="account-select"
                        :options="cmplAcntList"
                        :callGetValue="getAccountValue"
                        :preSlctedValue="selectedCmplAccList"
                        :headTitle="$t('POLICY.ADD_POPUP.DESC_SELECT_STEP_2')"
                        :isLoading="isAccountLoading"
                        key="account-select"
                    />
                </div>
                <div v-if="isShowStep3" style="width: 100%">
                    <p>{{ $t('POLICY.ADD_POPUP.DESC_STEP_3')}}</p>
                    <GroupSelect class="mt-4"
                        id="region-select"
                        :options="treeOptions"
                        :callGetValue="getTreeValue"
                        :preSlctedValue="preSlctedValue"
                        :headTitle="$t('POLICY.ADD_POPUP.DESC_SELECT_STEP_3')"
                        :isLoading="isRegionLoading"
                        key="region-select"
                    />
                </div>
                
            </div>
        </div>
    </div>
    
</template>
<script>
import HorizontalSchedule from '../../common/HorizontalSchedule.vue';
import GroupSelect from '../../common/GroupSelect/GroupSelect.vue';
import {mapGetters} from "vuex";
export default {
    name: 'AddingSchePopup',
    components: {HorizontalSchedule, GroupSelect},
    data() {
        return {
            isSchedule: false,
            doCmpl: true,
            scheInfo: {},
            cmplAcntList: [],
            selectedCmplAccList: [],
            originAcntList: [],
            treeOptions: [],
            treeValue: [],
            preSlctedValue: [],
            regions: [],
            classStep1: 'focused-',
            classStep2: '',
            classStep3: '',
            isShowStep1: true,
            isShowStep2: false,
            isShowStep3: false,
            isAccountLoading: true,
            isRegionLoading: true,
        }
    },
    props: {
        callSetScheInfo: Function,
        vendors: {
			type: Array,
			default: ()=>[]
		},
        step: {
            type: Number,
            default: 1
        },
        callGetStep: {
			type: Function,
			default: ()=>{}
		},
    },
    watch: {
        doCmpl(newval, olv) {
            this.scheInfo['doCmpl'] = newval;
            this.callSetScheInfo(this.scheInfo);
        },
        isSchedule(newVal, olv) {
            this.scheInfo['isSchedule'] = newVal;
            this.scheInfo['execType'] = 'F';
            this.scheInfo['doCmpl'] = this.doCmpl;
            if (newVal) {
                this.scheInfo['execType'] = 'A';
                this.scheInfo['dt'] = '00:00';
                this.scheInfo['browserTimeZone'] = moment().format('Z');
                this.scheInfo['peri'] = 'D';
                this.scheInfo['day'] = null;
            }
            this.callSetScheInfo(this.scheInfo);
        },
        selectedCmplAccList(newVal, olv) {
            this.callSetScheInfo({'accounts': newVal});
        },
        treeValue(newVal, olv) {
            this.callSetScheInfo({'regions': newVal});
        },
        step(newVal, olv) {
            this.onSelectStep(newVal);
        }
    },
    mounted() {
        this.getRegions();
        this.getCmplAcntList();
    },
    computed : {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
    },
    methods: {
        setSelectedAcntList(selectedList) {
            this.selectedCmplAccList = selectedList;
        },
        selectAllAccounts(isAll) {
            if (isAll && this.cmplAcntList) {
                this.selectedCmplAccList = this.cmplAcntList.map(e=>e.accId);
            } else {
                this.selectedCmplAccList = [];   
            }
        },
        filterCmplAccounts(searchTxt) {
            this.cmplAcntList = _.filter(this.originAcntList, function (o) {
                return o.accId.includes(searchTxt) || o.accAlias.toLowerCase().includes(searchTxt.toLowerCase());
            })
        },
        getTreeValue(value) {
            if (value.length == 0) {
                this.treeValue = value;
            } else {
                this.treeValue = this.getRegionValue(value);
            }
            this.preSlctedValue = value;
        },
        getAccountValue(value) {
            this.selectedCmplAccList = value;
        },
        createTreeValues(regions) {
            this.regions = [];
            let preSlctedValue = [];
            regions = regions.filter(region => region.selected !== 'N');
            let vendors = (this.vendors || []).map(item=>{return item.toLowerCase()});
            vendors = _.union(vendors);
            const tree = [];
            let listRegion = [];
            vendors.forEach((vendor)=>{
                let children = regions.filter(vnode => vnode.vendor === vendor);
                listRegion = listRegion.concat(children);
                children = children.map(item=>{return {id: item.rgnId, label: item.rgnNm}});
                tree.push({id: vendor, label: this.Common.getShortName(vendor), children});
            });
            listRegion.forEach((region)=>{
                preSlctedValue.push(region.rgnId);
            })
            this.treeOptions = tree;
            this.regions = listRegion;
            this.preSlctedValue = preSlctedValue;
            this.callSetScheInfo({'regions': this.getRegionValue(preSlctedValue)});
            this.isRegionLoading = false;
        },
        async getRegions() {
            const url = "/api/governance/setting/region";
            const header = {
                "cmpnId": this.curCmpnId,
            };
            try {
                const response = await this.http.post(url, JSON.stringify(header));
                if (response.data.status === 'ok') {
                    this.createTreeValues(response.data.result);
                }
            } catch(err) {
                console.error("getRegions: ", err);
            } finally {
                this.pending = false;
            }
        },
        async getCmplAcntList() {
            const url = "/api/governance/all/acnt";
            const header = {
                cmpnId: this.curCmpnId,
            };
            const result = await this.http.post(url, JSON.stringify(header))
            if(result.status === 200){
                let originAcntList = result.data.result.list;
                let vendors = (this.vendors || []).map(item=>{return item.toLowerCase()});
                vendors = _.union(vendors);
                let cmplAcntList = [];
                let listAccount = [];
                let preSlctedValue = [];
                vendors.forEach((vendor)=>{
                    let children = originAcntList.filter(vnode => {
                        let temVendor = vnode.vendor;
                        if (temVendor === 'azure') {
                            temVendor = 'azu'
                        }
                        if (temVendor === vendor) {
                            return true;
                        }
                        return false;
                    });
                    listAccount = listAccount.concat(children);
                    children = children.map(item=>{return {id: item.accId, label: item.accAlias}});
                    cmplAcntList.push({id: vendor, label: this.Common.getShortName(vendor), children});
                });
                listAccount.forEach((acc)=>{
                    preSlctedValue.push(acc.accId);
                })
                this.cmplAcntList = cmplAcntList;
                this.selectedCmplAccList = preSlctedValue;
                this.originAcntList = listAccount;
                this.isAccountLoading = false;
            }
        },
        onSelectStep(step) {
            if (step === 3 && this.selectedCmplAccList.length === 0) {
                return;
            }
            this.callGetStep(step);
            switch (step) {
                case 1:
                    this.classStep1 = 'focused-';
                    this.classStep2 = '';
                    this.classStep3 = '';

                    this.isShowStep1 = true;
                    this.isShowStep2 = false;
                    this.isShowStep3 = false;
                    break;
                case 2:
                    this.classStep2 = 'focused-';
                    this.classStep1 = 'done-';
                    this.classStep3 = '';

                    this.isShowStep1 = false;
                    this.isShowStep2 = true;
                    this.isShowStep3 = false;
                    break;
                case 3:
                    this.classStep3 = 'focused-';
                    this.classStep1 = 'done-';
                    this.classStep2 = 'done-';

                    this.isShowStep1 = false;
                    this.isShowStep2 = false;
                    this.isShowStep3 = true;
                    break;
                default:
                    break;
            }
        },
        getRegionValue(value) {
            let regionValue = [];
            this.regions.forEach((region)=>{
                let children = value.filter((regionId) => region.rgnId === regionId);
                if (children.length !== 0) {
                    regionValue.push({vendor:region.vendor, rgnId:region.rgnId, selected:'Y'});
                } else {
                    regionValue.push({vendor:region.vendor, rgnId:region.rgnId, selected:'N'});
                }
                
            });
            return regionValue;
        }
    }
}
</script>
<style scoped>
input[type=checkbox] {
    -webkit-appearance:checkbox;
    margin: 4px 3px 3px;
    width: 15px;
    height: 15px;
}
label {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: .75rem;
    font-weight: 400;
    color: #222222;
    line-height: 1.5em;
}
/deep/ .body-message-sche .form-item.relative {
    padding: 0 !important;
}
/deep/ .body-message-sche .form-item.relative .hstack .go-vendor {
    margin-right: 8px !important;
}
.step-body {
    padding: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/policy/policyComponents/AddingSchePopup.vue